import { ComponentType, FC, PropsWithChildren, ReactNode } from 'react';
import { AText } from '../AText';
import { Box } from '../Box';
import { SliderItems } from '../SliderItems';

import styles from './index.module.css';

interface MainMenuItem {
  id: string | number;
  link: string;
  title: string;
  logoUrl?: string;
  tag?: string;
  tagColor?: string;
}

interface SubMenuProps {
  mainMenuItems?: MainMenuItem[];
  SecondaryItems?: ReactNode;
  NavLink: ComponentType<
    PropsWithChildren<{
      to: string;
      className?: string;
      activeClassName?: string;
      isActive: () => boolean;
    }>
  >;
  isActive: (link: string) => boolean;
  isDesktop: boolean;
  dataRolePrefix?: string;
}

export const SubMenu: FC<SubMenuProps> = ({
  mainMenuItems = [],
  SecondaryItems = null,
  NavLink,
  isActive,
  isDesktop,
  dataRolePrefix = ''
}) => (
  <Box justify="between" className={styles.container}>
    <Box className={styles.sliderItemsWrapper}>
      <SliderItems isButtonsEnabled={true} isDesktop={isDesktop}>
        {mainMenuItems.map(({ id, link, title, logoUrl, tag, tagColor }) => {
          const isActiveItem = isActive(link);
          return (
            <Box
              key={id}
              data-role={`${dataRolePrefix}-${id}`}
              className={styles.mainMenuLinkWrapper}
            >
              {tag && (
                <Box
                  className={styles.mainMenuTag}
                  padding="0 xs"
                  style={{
                    backgroundColor: tagColor
                  }}
                >
                  <AText breed="BU" size="2xs" color="txt_color_4">
                    {tag}
                  </AText>
                </Box>
              )}
              <Box align="center" className={styles.mainMenuItem}>
                {logoUrl ? (
                  <Box className={styles.imgWrapper}>
                    <img className={styles.imgIcon} src={logoUrl} alt="logo" />
                  </Box>
                ) : (
                  <NavLink
                    isActive={() => isActive(link)}
                    className={styles.mainMenuLink}
                    to={link}
                  >
                    <AText
                      breed={isActiveItem ? 'BU' : 'RU'}
                      color={
                        isActiveItem ? 'sub_menu_active' : 'sub_menu_default'
                      }
                      size="m"
                    >
                      {title}
                    </AText>
                  </NavLink>
                )}
              </Box>
            </Box>
          );
        })}
      </SliderItems>
    </Box>
    {SecondaryItems}
  </Box>
);
